import { useApp } from "../context/AppContext";
import { tr } from "../i18n/translations";

export default function TrustBanner() {
  const { lang } = useApp();
  const stats = [
    { num: "5 000+", label: tr(lang, "trust_pros") },
    { num: "100%", label: tr(lang, "trust_delivery") },
    { num: "10", label: tr(lang, "trust_langs") },
  ];
  return (
    <section className="bg-pedablue text-ivory" data-testid="trust-banner">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-12 grid md:grid-cols-3 gap-8">
        {stats.map((s, i) => (
          <div key={i} className="text-center md:text-start">
            <p className="font-display text-5xl md:text-6xl font-light tracking-tight">{s.num}</p>
            <p className="text-ivory/70 text-sm mt-2 uppercase tracking-widest">{s.label}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
